export class Hero {
  id: number;
  name: string;
}



// WEBPACK FOOTER //
// ./src/app/components/heroes/hero.ts